export class BankWireTransferConstants {
    public static WireTransferCountries = ["BGR","MKD"];
    public static BankTransferCountries = ["BGR","MKD"]
}


// WEBPACK FOOTER //
// ./src/app/customerservice/constants/bank-wire-transfer-configuration.constants.ts